import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export const ErrorModal = ({ showModal, handleClose, errorMessage, title = "Connection Error" }) => {
    return (
        <Modal show={showModal} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ textAlign: 'center', padding: '10px' }}>
                    <i className="material-icons" style={{ fontSize: '48px', color: '#f44336', marginBottom: '15px' }}>
                        error_outline
                    </i>
                    <p style={{ fontSize: '16px', lineHeight: '1.5' }}>
                        {errorMessage}
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: 'center' }}>
                <Button variant="primary" onClick={handleClose}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
